import { Box } from '@mui/material'
import { useTranslations } from 'next-intl'
import {
  SectionHeader,
  SectionWrapper,
  type SectionHeaderData,
  type SectionHeaderProps,
} from '@components/common'
import BeforeAfterCostimizer, {
  type FeatureListData,
} from '@components/feature/home/WhyChooseUs/ChooseCard'
import { getStyles, type CustomStyles } from '@utils/styles'
import { CommonButton } from '../CommonButton'
import defaultStyles, { type StylesClassNames } from './styles'

export type ComparisonSectionData = {
  sectionHeaderData?: SectionHeaderData
  partnersTypeData: FeatureListData[]
  darkBg?: boolean
}

export type ComparisonSectionProps = ComparisonSectionData & {
  sectionHeaderProps?: SectionHeaderProps
  csx?: CustomStyles<StylesClassNames>
  showDivider?: 'top' | 'bottom' | 'both' | 'none'
  alternateSectionBg?: boolean
}

export function ComparisonSection({
  sectionHeaderData,
  partnersTypeData,
  sectionHeaderProps,
  csx,
  darkBg = false,
  showDivider,
  alternateSectionBg = false,
}: ComparisonSectionProps) {
  const styles = getStyles(defaultStyles, csx)
  const t = useTranslations('ComparisionSection')
  return (
    <SectionWrapper
      alternateBg={darkBg}
      showDivider={showDivider}
      alternateSectionBg={alternateSectionBg}
      {...styles('wrapper')}
    >
      {sectionHeaderData && (
        <SectionHeader
          {...sectionHeaderData}
          {...sectionHeaderProps}
          darkBg={darkBg}
        />
      )}
      <Box {...styles('cardWrapper')}>
        {partnersTypeData.map((item, index) => (
          <BeforeAfterCostimizer
            key={item.title}
            list={item.list}
            title={item.title}
            chipLabel={item.chipLabel}
            description={item.description}
            isPositive={index % 2 !== 0}
            imageData={item.imageData}
            darkBg={darkBg}
            actionButtonData={item.actionButtonData}
            csx={{
              root: {
                width: { xs: '100%', md: '50%' },
              },
            }}
          />
        ))}
      </Box>
    </SectionWrapper>
  )
}
